import { Box, Button, Grid, GridItem, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react'
import { getCustomerById, getAdhocQuoteById } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ModalConvertToProject } from './ModalConvertToProject'
import { getAssetUrl } from 'lib'
import { useNavigate } from 'react-router-dom'

export const ModalActions = ({ quoteId, pdf, isOpen, onClose }) => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [quote, setQuote] = useState(null)
  const [customer, setCustomer] = useState(null)
  const disclosureConvertToProject = useDisclosure()

  useEffect(() => {
    if (!quoteId) return
    const load = async () => {
      try {
        const resp = await getAdhocQuoteById(quoteId)
        setQuote(resp)
        const customerResp = await getCustomerById(resp.customerId)
        setCustomer(customerResp)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [quoteId])

  const handleOpenQuote = () => {
    window.open(getAssetUrl(pdf))
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text fontSize="xl">Actions for Quote #{quote?.quoteNo}</Text>
            <Text fontSize="sm">{customer?.firstname} {customer?.lastname} at {customer?.company}</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Grid
              templateColumns="1fr 1fr"
              gap={5}
            >
              <GridItem>
                <Button flexDirection="column" px={4} py={6} h="fit-content" w="100%" onClick={handleOpenQuote}>
                  <Text fontSize="md" fontWeight="bold" textTransform="uppercase">View Quote</Text>
                  <Text fontSize="sm" color="gray.500" mt={1}>preview the pdf online</Text>
                  <Box position="absolute" left="10px" opacity="0.2">
                  </Box>
                </Button>
              </GridItem>
              {/* <GridItem>
                <Button flexDirection="column" px={4} py={6} h="fit-content" w="100%">
                  <Text fontSize="md" fontWeight="bold" textTransform="uppercase">Email Quote</Text>
                  <Text fontSize="sm" color="gray.500" mt={1}>send the quote to the customer</Text>
                  <Box position="absolute" left="10px" opacity="0.2">
                  </Box>
                </Button>
              </GridItem> */}
              <GridItem>
                <Button flexDirection="column" px={4} py={6} h="fit-content" w="100%" onClick={() => { onClose(); disclosureConvertToProject.onOpen() }}>
                  <Text fontSize="md" fontWeight="bold" textTransform="uppercase">Convert To Project</Text>
                  <Text fontSize="sm" color="gray.500" mt={1}>finalize quote and convert to project</Text>
                  <Box position="absolute" left="10px" opacity="0.2">
                  </Box>
                </Button>
              </GridItem>
              <GridItem>
                <Button flexDirection="column" px={4} py={6} h="fit-content" w="100%" onClick={() => navigate('/artwork-requests/add?quoteNumber=' + quote?.quoteNo)}>
                  <Text fontSize="md" fontWeight="bold" textTransform="uppercase">Artwork Request</Text>
                  <Text fontSize="sm" color="gray.500" mt={1}>create a artwork request from quote</Text>
                  <Box position="absolute" left="10px" opacity="0.2">
                  </Box>
                </Button>
              </GridItem>
              <GridItem>
                <Button flexDirection="column" px={4} py={6} h="fit-content" w="100%" onClick={() => { onClose(); navigate(`/quotes/adhoc-quotes/add?duplicateFrom=${quoteId}`) }}>
                  <Text fontSize="md" fontWeight="bold" textTransform="uppercase">Duplicate Quote</Text>
                  <Text fontSize="sm" color="gray.500" mt={1}>create a new quote with the same values</Text>
                  <Box position="absolute" left="10px" opacity="0.2">
                  </Box>
                </Button>
              </GridItem>
            </Grid>
          </ModalBody>
        </ModalContent>
      </Modal>
      <ModalConvertToProject
        quote={quote}
        customer={customer}
        {...disclosureConvertToProject}
      />
    </>
  )
}

ModalActions.propTypes = {
  quoteId: PropTypes.number,
  pdf: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}
